import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function FilterPill({
  content, filter, type, removeFilter = null,
}) {
  return (
    <div className="filter-pill">
      {filter.text}
      {removeFilter && (
        <span onClick={() => { removeFilter(filter.value, type) }}>
          <Icon type={['far', 'times']} color="grey-dark" className="filter-pill__remove" notSpaced />
        </span>
      )}
    </div>
  )
}

FilterPill.propTypes = {
  filter: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
  removeFilter: PropTypes.func,
}

export default FilterPill
